// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import { GLYPH_VIEWBOX, GLYPH_STROKE } from './glyph';
import type { SymbolGlyphProps } from './glyph';
import { Leads } from './Leads';

/**
 * PDU — a box around a two-winding transformer.
 *
 * Every PDU on this drawing steps voltage down internally (`480 → 415/240 V`
 * in the mock's own label), so the interlinked coils are what it actually is,
 * not decoration. It also keeps the PDU legible against `UpsSymbol`: coils
 * versus conversion marks, at the same size.
 */
export const PduSymbol = ({ size = 18, leads }: SymbolGlyphProps) => (
  <svg
    width={size}
    height={size}
    viewBox={GLYPH_VIEWBOX}
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <Leads top={4} bottom={20} leads={leads} />
    <rect
      x="4"
      y="4"
      width="16"
      height="16"
      rx="1"
      stroke="currentColor"
      strokeWidth={GLYPH_STROKE}
    />
    <circle cx="12" cy="10" r="3.4" stroke="currentColor" strokeWidth={GLYPH_STROKE - 0.4} />
    <circle cx="12" cy="14.6" r="3.4" stroke="currentColor" strokeWidth={GLYPH_STROKE - 0.4} />
  </svg>
);
